jQuery( document ).ready( function () {
    var height = jQuery( '.e-footer' ).height();
    jQuery( '.e-content' ).css( {
        marginBottom: height
    } );
} );​

